import axios from 'axios';
import { API3_HOST } from '../../helpers/urlHelper';
import { baseSearch, basePost } from 'services/base-services/baseService';

axios.defaults.withCredentials = true;
const baseURL = `${API3_HOST}/sls-wpo-discrepancy-notes`;

const searchDiscrepancyNote = async request => {
  return await baseSearch(`${baseURL}`, request);
};

const createDiscrepancyNote = async request => {
  return await basePost(`${baseURL}`, request);
};

export { searchDiscrepancyNote, createDiscrepancyNote };
